var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"picon ",class:_vm.isClicked ? 'icon-feather-check text-muted': 'icon-feather-copy text-warning',attrs:{"role":"button"},on:{"click":_vm.copyIt}})])}
var staticRenderFns = []

export { render, staticRenderFns }